export default "__VITE_ASSET__Cpiqr0r1__"